import Super from '../../core/button.gjs';
import styles from './destructive.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Destructive',
  description: `
    Destructive button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Destructive Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/destructive.gjs',
  },
};

export default class SpdsActionButtonDestructive extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-destructive';
  variantStyles = styles;
}

export const ACTION_BUTTON_DESTRUCTIVE_METADATA = SpdsActionButtonDestructive.metadata;
